import React from "react";
import india from "../../../Assets/Red_Theme/indiaFlag.png"
import usa from "../../../Assets/Red_Theme/usaFlag.png"
import newZealandFlag from "../../../Assets/Red_Theme/newZealandFlag.png"
import australia from "../../../Assets/Red_Theme/australia.png"
import "./index.scss";
import { BiSolidPhoneCall } from "react-icons/bi";
import { Link } from "react-router-dom";
import {  MdOutlineSupportAgent } from "react-icons/md";
import { RiMailSendLine } from "react-icons/ri";
import { FaBehance, FaLinkedinIn } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { IoCallOutline } from "react-icons/io5";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="outbox">
          <div className="customeBorder">
            <div className="row m-0 border-b">
              <div className="col-xl-8 col-lg-8 col-md-12 col-12 p-0 border-r">
                <div className="links-box">
                  <div className="linksPart">
                    <h2>Top Services</h2>
                    <ul className="footer-link">
                      <li>
                        <a>Mobile App</a>
                      </li>
                      <li>
                        <a>Website</a>
                      </li>
                      <li>
                        <a>JavaScript</a>
                      </li>
                      <li>
                        <a>Framework</a>
                      </li>
                      <li>
                        <a>ECommerce</a>
                      </li>
                      <li>
                        <a>Blockchain</a>
                      </li>
                      <li>
                        <a>On Demand</a>
                      </li>
                    </ul>
                  </div>
                  <div className="linksPart">
                    <h2>Technologies</h2>
                    <ul className="footer-link">
                      <li>
                        <a>React Js</a>
                      </li>
                      <li>
                        <a>Angular Js</a>
                      </li>
                      <li>
                        <a>Node Js</a>
                      </li>
                      <li>
                        <a>Python</a>
                      </li>
                      <li>
                        <a>UI UX Design</a>
                      </li>
                      <li>
                        <a>Android</a>
                      </li>
                      <li>
                        <a>Apple</a>
                      </li>
                      <li>
                        <a>ASP.Net</a>
                      </li>
                    </ul>
                  </div>
                  <div className="linksPart">
                    <h2>Industries</h2>
                    <ul className="footer-link">
                      <li>
                        <a>Healthcare apps</a>
                      </li>
                      <li>
                        <a>On demand apps</a>
                      </li>
                      <li>
                        <a>Finance apps</a>
                      </li>
                      <li>
                        <a>Social networking apps</a>
                      </li>
                      <li>
                        <a>Restaurant apps</a>
                      </li>
                      <li>
                        <a>Entertainment apps</a>
                      </li>
                      <li>
                        <a>Education apps</a>
                      </li>
                    </ul>
                  </div>
                  <div className="linksPart">
                    <h2>Services</h2>
                    <ul className="footer-link">
                      <li>
                        <Link to="/services/uiux-designs">UI/UX Designs</Link>
                      </li>
                      <li>
                        <Link to="/services/application-development">App Development</Link>
                      </li>
                      <li>
                        <Link to="/services/software-development">Software Development</Link>
                      </li>
                      <li>
                        <Link to="/services/ai-artificial-intelligence">AI -Artificial Intelligence</Link>
                      </li>
                      <li>
                        <Link to="/services/e-commerce-services">Ecommerce Services</Link>
                      </li>
                      <li>
                        <Link to="/services/quality-assurance">Quality Assurance</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-12 col-12 p-0">
                <div className="outerbox">
                  <div className="letsTalkBox">
                    <BiSolidPhoneCall className="icon" />
                    Let&apos;s Talk
                  </div>
                  <div className="detailsBox">
                    <ul className="contact-details">
                      <li>
                        <RiMailSendLine className="icon" />
                        <div className="info">
                          <p>Business Inquiries</p>
                          <Link to="mailto: info@vidhaninfotech.com">
                            info@vidhaninfotech.com
                          </Link>
                        </div>
                      </li>
                      <li>
                        <MdOutlineSupportAgent className="icon" />
                        <div className="info">
                          <p>Hr Department</p>
                          <Link to="tel: +91 8780 838 782">
                            +91 8780 838 782
                          </Link>
                        </div>
                      </li>
                      <li>
                        <IoCallOutline className="icon" />
                        <div className="info">
                          <p>Sales Department</p>
                          <Link to="tel: +91 8160 455 387">
                            +91 8160 455 387
                          </Link>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="row m-0 border-b">
              <div className="col-xl-8 col-lg-8 col-md-12 col-12 p-0 border-r">
                <div className="links-box">
                  <div className="branchbox">
                    <img src={india} alt="" />
                    <p>India</p>
                    <span>+91 81604 55387</span>
                  </div>
                  <div className="branchbox">
                    <img src={usa} alt="" />
                    <p>USA</p>
                    <span>+1 (850) 857-2152</span>
                  </div>
                  <div className="branchbox">
                    <img src={newZealandFlag} alt="" />
                    <p>New Zealand</p>
                    <span>+64 22 899 9264</span>
                  </div>
                  <div className="branchbox">
                    <img src={australia} alt="" />
                    <p>Australia</p>
                    <span>+61 423 660 821</span>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-12 col-12 p-0">
                <div className="mailBox">
                  <div className="inputBox">
                    <input className="form-control custome-input" placeholder="Enter Your Email" type="email" name="" id="" />
                    <button className="sendBtn">Subscribe</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="row m-0">
              <div className="col-xl-8 col-lg-8 col-md-12 col-12 p-0 border-r">
                <div className="links-box">
                  <div className="copyright">
                    <p>© Vidhan Infotech Private Limited 2025.</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-12 col-12 p-0">
                <div className="socialBox">
                  <div className="socialIcons">
                    <ul>
                      <li>
                        <Link target="_blank" to="https://www.linkedin.com/company/vidhan-infotech-pvt-ltd/">
                          <FaLinkedinIn />
                        </Link>
                      </li>
                      <li>
                        <Link target="_blank" to="https://www.facebook.com/people/Vidhan-Infotech/pfbid036PsPqkewqEBimCLdBqaXLA9ESf1t5nYH3zeiZPFcfC1mSw48djQTy8eMiEr7bt6Yl/">
                          <FaFacebookF />
                        </Link>
                      </li>
                      <li>
                        <Link target="_blank" to="https://www.instagram.com/vidhaninfotech/">
                          <FaInstagram />
                        </Link>
                      </li>
                      <li>
                        <Link target="_blank" to="https://www.behance.net/vidhaninfotech">
                          <FaBehance />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
export default React.memo(Footer);
